import styled, { css } from 'styled-components';
import type { FlattenSimpleInterpolation, ThemeProps } from 'styled-components';
import type { SystemColorType, ThemeType } from '../../util/types';
import { getPolishedColors } from '../../util/styled';
import { ICON_MATERIAL } from '../../util/data-id';

export const getAlertColors = (props: ThemeProps<ThemeType> & { $color: SystemColorType, $invert: boolean }): FlattenSimpleInterpolation => {
  const colors = getPolishedColors(props);

  if (props.$invert) {
    return css`
      color: ${colors.main.readable};
      border: 2px solid ${colors.main.color};
      background: ${colors.main.color};
    `;
  }
  return css`
    color: ${props.theme.colors.muted};
    border: 2px solid ${colors.main.color};
  `;
};

export const AlertWrapperStyled =  styled('div')<{ $color: SystemColorType, $invert: boolean }>`
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;    
  line-height: 1.5rem;
  font-style: italic;
  border-radius: ${(props) => props.theme.radius.default};
  ${(props) => getAlertColors(props)} 
  
  [data-id='${ICON_MATERIAL}'] {
    width: 100%;
    height: 100%;
  }
  p {
    margin-bottom: 5px;
  }
  ul > li {    
    list-style-position: inside;
    list-style-type: circle;
  }
`;
